export default __webpack_public_path__ + "62f7b2e963a93ecbe462786f32522983.svg";